export default "__VITE_ASSET__DeGTGub2__"